import { SPACE, THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { cardStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	finishForm: {
		...THEME.common.scrollBar,
		maxHeight: '60vh',
		minHeight: 0,
		overflowY: 'auto',
	},
	// The sidebar's own chrome. Only one host wrapped this in cardStyle, so on every other surface it
	// drew a harder border than the cards beside it.
	card: {
		...cardStyle,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		flexDirection: 'column',
		gap: SPACE[8],
		padding: SPACE[16],
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
	},
	detail: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	metaRow: {
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[4],
	},
	metaLabel: {
		color: THEME.colors.text.light,
	},
	metaValue: {
		color: THEME.colors.text.main,
	},
	explanation: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
		marginTop: SPACE[4],
	},
	actionButton: {
		alignSelf: 'flex-start',
		marginTop: SPACE[4],
	},
	annotations: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	annotationLink: {
		alignSelf: 'flex-start',
	},
	// The link variant keeps the button's side padding, which would indent it past the text above.
	flushLink: {
		paddingLeft: 0,
		paddingRight: 0,
	},
});
